import { query } from "./strapi";

export interface NewsletterSubscriptionResponse {
  success: boolean;
  message: string;
  subscriptionId?: string;
}

/**
 * Subscribe to newsletter
 * @param email - Email address to subscribe
 * @param source - Source of subscription (optional)
 * @returns Promise with subscription response
 */
export async function subscribeNewsletter(
  email: string,
  source: string = "home_page"
): Promise<NewsletterSubscriptionResponse> {
  try {
    const response = await query("newsletter/subscribe", {
      method: "POST",
      body: JSON.stringify({
        email,
        source,
        subscription_status: "active",
      }),
    });

    if (!response) {
      throw new Error("No response from server");
    }

    return {
      success: response.success || false,
      message: response.message || "Subscription processed",
      subscriptionId: response.subscriptionId,
    };
  } catch (error) {
    console.error("Error subscribing to newsletter:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Failed to subscribe to newsletter"
    );
  }
}
